"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hedgeProtocolConfiguration = exports.healthThresholdConfiguration = exports.directMessageConfiguration = exports.broadcastMessageConfiguration = void 0;
const broadcastMessageConfiguration = ({ topicName, }) => {
    return {
        filterType: 'BROADCAST_MESSAGES',
        filterOptions: {},
        sourceType: 'BROADCAST',
        createSource: {
            address: topicName,
        },
    };
};
exports.broadcastMessageConfiguration = broadcastMessageConfiguration;
const directMessageConfiguration = (params) => {
    const type = params === null || params === void 0 ? void 0 : params.type;
    return {
        sourceType: 'DIRECT_PUSH',
        filterType: 'DIRECT_TENANT_MESSAGES',
        filterOptions: type === undefined ? null : { directMessageType: type },
    };
};
exports.directMessageConfiguration = directMessageConfiguration;
const healthThresholdConfiguration = ({ alertFrequency, percentage, }) => {
    return {
        sourceType: 'DIRECT_PUSH',
        filterType: 'VALUE_THRESHOLD',
        filterOptions: {
            alertFrequency,
            threshold: percentage,
        },
    };
};
exports.healthThresholdConfiguration = healthThresholdConfiguration;
const hedgeProtocolConfiguration = ({ walletAddress, }) => {
    return {
        filterType: 'LIQUIDATIONS',
        filterOptions: {},
        sourceType: 'HEDGE_PROTOCOL',
        createSource: {
            address: walletAddress,
        },
    };
};
exports.hedgeProtocolConfiguration = hedgeProtocolConfiguration;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWxlcnRDb25maWd1cmF0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL3V0aWxzL0FsZXJ0Q29uZmlndXJhdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFjTyxNQUFNLDZCQUE2QixHQUFHLENBQUMsRUFDNUMsU0FBUyxHQUdULEVBQXNCLEVBQUU7SUFDeEIsT0FBTztRQUNMLFVBQVUsRUFBRSxvQkFBb0I7UUFDaEMsYUFBYSxFQUFFLEVBQUU7UUFDakIsVUFBVSxFQUFFLFdBQVc7UUFDdkIsWUFBWSxFQUFFO1lBQ1osT0FBTyxFQUFFLFNBQVM7U0FDbkI7S0FDRixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBYlcsUUFBQSw2QkFBNkIsaUNBYXhDO0FBRUssTUFBTSwwQkFBMEIsR0FBRyxDQUN4QyxNQUVFLEVBQ2tCLEVBQUU7SUFDdEIsTUFBTSxJQUFJLEdBQUcsTUFBTSxhQUFOLE1BQU0sdUJBQU4sTUFBTSxDQUFFLElBQUksQ0FBQztJQUMxQixPQUFPO1FBQ0wsVUFBVSxFQUFFLGFBQWE7UUFDekIsVUFBVSxFQUFFLHdCQUF3QjtRQUNwQyxhQUFhLEVBQUUsSUFBSSxLQUFLLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLGlCQUFpQixFQUFFLElBQUksRUFBRTtLQUN2RSxDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBWFcsUUFBQSwwQkFBMEIsOEJBV3JDO0FBRUssTUFBTSw0QkFBNEIsR0FBRyxDQUFDLEVBQzNDLGNBQWMsRUFDZCxVQUFVLEdBSVYsRUFBc0IsRUFBRTtJQUN4QixPQUFPO1FBQ0wsVUFBVSxFQUFFLGFBQWE7UUFDekIsVUFBVSxFQUFFLGlCQUFpQjtRQUM3QixhQUFhLEVBQUU7WUFDYixjQUFjO1lBQ2QsU0FBUyxFQUFFLFVBQVU7U0FDdEI7S0FDRixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBZlcsUUFBQSw0QkFBNEIsZ0NBZXZDO0FBRUssTUFBTSwwQkFBMEIsR0FBRyxDQUFDLEVBQ3pDLGFBQWEsR0FHYixFQUFzQixFQUFFO0lBQ3hCLE9BQU87UUFDTCxVQUFVLEVBQUUsY0FBYztRQUMxQixhQUFhLEVBQUUsRUFBRTtRQUNqQixVQUFVLEVBQUUsZ0JBQWdCO1FBQzVCLFlBQVksRUFBRTtZQUNaLE9BQU8sRUFBRSxhQUFhO1NBQ3ZCO0tBQ0YsQ0FBQztBQUNKLENBQUMsQ0FBQztBQWJXLFFBQUEsMEJBQTBCLDhCQWFyQyJ9